<script>
    import BasePageSorting from '../base/BasePageSorting';

    export default {
        extends: BasePageSorting,
        data() {
            return {
                eventName: 'movie_filter:changed',
                defaultSortingOptionIndex: 0,
            };
        },
        mounted() {
            this.setSortingOptions(MrMovie.defaults.moviesOverviewSortingOptions);
            this.emitSelectedOption();
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/movies/MoviesOverviewSorting.vue